export default function Form1() {
  return (
    <div className="prose max-w-none">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Հայտի ձև 1</h2>
      <h4 className="text-lg font-semibold text-gray-700 mb-4">Հայտ 1-ի նմուշ օրինակ</h4>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        <img src="https://certification.am/wp-content/uploads/2025/04/Screenshot-2025-04-22-2125231st.png" alt="Form 1 Page 1" className="w-full border rounded-lg shadow-sm" />
        <img src="https://certification.am/wp-content/uploads/2025/04/Screenshot-2025-04-22-2126171st.png" alt="Form 1 Page 2" className="w-full border rounded-lg shadow-sm" />
      </div>

      <a 
        href="https://certification.am/wp-content/uploads/2025/04/%D5%80%D5%A1%D5%B5%D5%BF-%D5%81%D6%87-1.docx" 
        target="_blank" 
        rel="noopener noreferrer"
        className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
        Ներբեռնել հայտը
      </a>
    </div>
  );
}
